import React, { Component } from 'react';

class StaffQualificationPrint extends Component {
	state = {};
	render() {
		const { Document } = this.props;
		console.log(Document, 'Qualification Data');
		return (
			<div>
				<div id="div1">
					<section class="mb-4">
						<div class="container">
							<div class="row rowStaffCheck" style={{ marginTop: 10 }}>
								<div class="col colStaffCheck">
									<label style={{ fontWeight: 'bold' }}>
										Qualification:{' '}
									</label>{' '}
									&nbsp;&nbsp;
									{Document && Document.qualificationName}
								</div>
								<div class="col colStaffCheck">
									{' '}
									<label style={{ fontWeight: 'bold' }}>Subject: </label>
									&nbsp;&nbsp; {Document && Document.board}
								</div>
							</div>
							<div class="row rowStaffCheck">
								<div class="col colStaffCheck">
									<label style={{ fontWeight: 'bold' }}>
										Year:
									</label>
									&nbsp;&nbsp; {Document && Document.qualificationYear}
								</div>
								<div class="col colStaffCheck">
									<label style={{ fontWeight: 'bold' }}>Institution:</label>
									&nbsp;&nbsp; {Document && Document.institute}{' '}
								</div>
							</div>
						</div>
					</section>
				</div>
			</div>
		);
	}
}

export default StaffQualificationPrint;
